import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfigurableHeaderComponent } from "./configurable-header/configurable-header.component";
import { MatIconModule } from "@angular/material/icon";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule } from "@angular/forms";
import { MatMenuModule } from "@angular/material/menu";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LoginTranslateService } from "src/app/shared/login-translation.service";
import { LoginTranslatePipe } from "src/app/shared/login-translate.pipe";
import { TRANSLATION_PROVIDERS } from "src/app/shared/translation/translation";
import { SmsAutocomplete } from './sms-autocomplete/sms-autocomplete.component';
@NgModule({
    imports: [CommonModule, MatIconModule, MatSelectModule, MatFormFieldModule, MatIconModule, MatCheckboxModule, FormsModule, MatMenuModule, MatTooltipModule, MatInputModule, ConfigurableHeaderComponent, DropdownComponent, LoginTranslatePipe, SmsAutocomplete],
    providers: [TRANSLATION_PROVIDERS, LoginTranslateService],
    exports: [ConfigurableHeaderComponent, DropdownComponent, LoginTranslatePipe, SmsAutocomplete],
    declarations: []
})
export class SharedModule {}
